module.exports = __webpack_public_path__ + "img/xtransfer.213a1680.png";